import * as React from 'react';
import PropTypes from 'prop-types';

import { DataGrid } from '@mui/x-data-grid';

import {
	getPracticeStaff,
	updatePracticeStaff,
} from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
	Alert,
	Snackbar,
	Box,
	Button,
	Grid,
	TextField,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Typography,
	IconButton,
	useMediaQuery,
	InputAdornment,
} from '@mui/material';
import BrandedLoader from '../../../../components/BrandedLoader/BrandedLoader';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import DialogTitle from '@mui/material/DialogTitle';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import { useTheme } from '@mui/material/styles';

import * as Yup from 'yup';

import CancelIcon from '@mui/icons-material/Cancel';
import dayjs from 'dayjs';
import {
	Add,
	Call,
	GroupOutlined,
	Search,
} from '@mui/icons-material';
import MaskedInput from 'react-text-mask';
import AddStaff from './AddStaff';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(900px, calc(100vw - 32px))',
	backgroundColor: 'white',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

const modalLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
	color: '#0b2450',
	mb: 0.7,
};

const modalFieldSx = {
	'& .MuiOutlinedInput-root': {
		minHeight: '42px',
		borderRadius: '6px',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
		backgroundColor: '#fff',
		boxShadow: 'none',
		'& fieldset': {
			borderColor: '#d7e3f4',
		},
		'&:hover fieldset': {
			borderColor: '#b8c9df',
		},
		'&.Mui-focused fieldset': {
			borderColor: '#2f6edb',
		},
	},
	'& .MuiInputBase-input': {
		padding: '10px 12px',
	},
	'& input[type="date"]': {
		minHeight: '20px',
	},
};

const modalMaskedInputStyle = {
	width: '100%',
	height: '42px',
	borderRadius: '6px',
	border: '1px solid #d7e3f4',
	padding: '10px 12px',
	boxSizing: 'border-box',
	outlineColor: '#2f6edb',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	backgroundColor: '#fff',
};

const modalSelectSx = {
	minHeight: '42px',
	borderRadius: '6px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	backgroundColor: '#fff',
	boxShadow: 'none',
	'& fieldset': {
		borderColor: '#d7e3f4',
	},
	'&:hover fieldset': {
		borderColor: '#b8c9df',
	},
	'&.Mui-focused fieldset': {
		borderColor: '#2f6edb',
	},
	'& .MuiSelect-select': {
		padding: '10px 12px',
	},
};

const modalSelectMenuProps = {
	PaperProps: {
		sx: {
			mt: 0.5,
			borderRadius: '6px',
			boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
			maxHeight: 280,
			'& .MuiMenuItem-root': {
				fontFamily: 'Poppins',
				fontSize: '13px',
				minHeight: '34px',
			},
		},
	},
};

function ViewStaff({ renderHandleFromChild }) {
	const [openAddStaffModal, setOpenAddStaffModal] = useState(false);
	// Edit Delete Popover states and functions are here
	const [anchorED, setAnchorED] = React.useState(null);
	const editDelete_pop_opens = Boolean(anchorED);
	const handleClickED = (event, params) => {
		// i am opening my popover from here and also setting values of modals from here am setting delete and edit modal states data from here

		setModalValues(params?.row);
		//setting deleteModal Data
		setDeleteUser(params?.row?.Fname);
		setDeleteID(params?.row?.id);

		setAnchorED(event.currentTarget);
	};
	const handleCloseED = () => {
		setAnchorED(null);
	};

	// const [anchorEl, setAnchorEl] = React.useState(null);
	const [staffs, setStaffs] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [specialtyFilter, setSpecialtyFilter] = useState('');

	// Modal States
	const [openModal, setOpenModal] = useState(false);
	const [modalValues, setModalValues] = useState({});

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Loader State
	const [loading, setLoading] = useState(false);
	// Dialog States
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};
	const schema = Yup.object().shape({
		Fname: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Lname: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Title: Yup.string().matches(/^[a-zA-Z\s]+$/, ' Alphabets only'),
		City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		State: Yup.string().matches(
			/^[a-zA-Z]+$/,
			'Alphabets without blank spaces'
		),
		Specialty: Yup.string().matches(/^[a-zA-Z\s]+$/, ' Alphabets only'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setModalValues((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	// Close Modal Function
	const handleCloseModal = () => {
		setOpenModal(false);
	};

	// Dialog Function
	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	const fetchStaff = async () => {
		setLoading(true);
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setLoading(false);
				setStaffs(response?.data);
			} else {
				setStaffs([]);
			}
		} catch (error) {
			console.error('Error fetching Staff:', error);
		}
	};

	useEffect(() => {
		fetchStaff();
	}, []);

	// Function -- Target Modal Textfields Values
	const targetModalValue = (event) => {
		event.preventDefault();
		setModalValues({
			...modalValues,
			[event.target.name]: event.target.value,
		});
	};

	// Function -- Edit Data
	const handleEdit = () => {
		// Close the action menu first, then open the modal
		setAnchorED(null);
		setOpenModal(true);
	};

	// Function Update Modal Values -- Edit Functionality
	const updateModalValues = async (modalValues) => {
		if (
			errors?.Title ||
			errors?.Fname ||
			errors?.Lname ||
			errors?.City ||
			errors?.Contact ||
			errors?.NPI ||
			errors?.State ||
			errors?.Zip
		) {
		} else {
			const resp = await updatePracticeStaff(modalValues.id, modalValues);
			if (resp?.request?.status === 200) {
				setAnchorED(null);
				handleCloseModal();
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('success');
				fetchStaff();
			} else {
				setLoading(false);
				setSeverity('error');
				handleClickSnackbar();
				// Snackbar Color Show
			}
		}
	};

	// Delete Object
	const deleteStatus = {
		Deleted: true,
	};
	// Function Delete Staff User
	const handleDeleteUser = () => {
		// Close the action menu first, then open the modal
		setAnchorED(null);
		setDeletePopupOpen(true);
	};
	// Funtion For Delete Staff ID
	const deleteStaff = async (deleteID) => {
		const response = await updatePracticeStaff(deleteID, deleteStatus);

		if (response?.request?.status === 200) {
			setDeletePopupOpen(false);
			setAnchorED(null);
			setLoading(true);
			handleClickSnackbar();
			setSeverity('error');
			try {
				const newData = await fetchStaff();
				setLoading(false);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
			setLoading(false);
		}
	};

	const rows =
		staffs &&
		staffs?.map((p) => ({
			id: p.id,
			Fname: p.Fname || '',
			Lname: p.Lname || '',
			UserName: p.Lname + ',' + p.Fname || '',
			Title: p.Title || '',
			Specialty: p.Specialty || '',
			Contact: p.Contact || '',
			Address: p.Address || '',
			Comments: p.Comments || '',
			//Dont'change DOB format because during Update API needs this format for updation
			DOB: dayjs(p.DOB).format('YYYY-MM-DD') || '',
			Gender: p.Gender || '',
			NPI: p.NPI || '',
			City: p.City || '',
			State: p.State || '',
			Zip: p.Zip || '',
		}));

	const specialties = [
		...new Set(rows?.map((row) => row.Specialty).filter(Boolean)),
	];

	const filteredRows = rows?.filter((row) => {
		const search = searchText.trim().toLowerCase();
		const matchesSearch =
			!search ||
			[
				row.Title,
				row.Fname,
				row.Lname,
				row.Specialty,
				row.NPI,
				row.Contact,
			].some((value) => (value || '').toLowerCase().includes(search));
		const matchesSpecialty =
			!specialtyFilter || row.Specialty === specialtyFilter;
		return matchesSearch && matchesSpecialty;
	});

	const getSpecialtyBadgeSx = (specialty) => {
		const normalized = (specialty || '').toLowerCase();
		const palette =
			normalized.includes('surgery')
				? { color: '#0f5bca', background: '#eaf2ff' }
				: normalized.includes('internal')
					? { color: '#17865a', background: '#e6f6ee' }
					: normalized.includes('pediatric')
						? { color: '#6d3edb', background: '#f0e9ff' }
						: normalized.includes('nurse')
							? { color: '#b7791f', background: '#fff4de' }
							: normalized.includes('family')
								? { color: '#0f766e', background: '#e6f8f7' }
								: normalized.includes('emergency')
									? { color: '#dc2626', background: '#ffe8e8' }
									: { color: '#526072', background: '#eef2f6' };

		return {
			...palette,
			display: 'inline-flex',
			alignItems: 'center',
			height: '24px',
			px: 1,
			borderRadius: '6px',
			fontFamily: 'Poppins',
			fontSize: '12px',
			fontWeight: 600,
		};
	};

	const renderTextCell = (params) => (
		<Typography
			component="span"
			sx={{
				color: params.value ? '#0b2450' : '#8b9ab0',
				fontFamily: 'Poppins',
				fontSize: '13px',
				fontWeight: 500,
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
			}}
		>
			{params.value || '-'}
		</Typography>
	);

	const columns = [
		// { field: 'id', headerName: 'Id', width: 40 },
		{ field: 'Title', headerName: 'Title', flex: 0.6, minWidth: 90, renderCell: renderTextCell },
		{ field: 'Fname', headerName: 'First Name', flex: 1, minWidth: 130, renderCell: renderTextCell },
		{ field: 'Lname', headerName: 'Last Name', flex: 1, minWidth: 130, renderCell: renderTextCell },
		{ field: 'DOB', headerName: 'DOB', flex: 0.8, minWidth: 120, renderCell: renderTextCell },
		{
			field: 'Specialty',
			headerName: 'Specialty',
			flex: 1.2,
			minWidth: 150,
			renderCell: (params) =>
				params.value ? (
					<Box sx={getSpecialtyBadgeSx(params.value)}>{params.value}</Box>
				) : (
					renderTextCell(params)
				),
		},
		{ field: 'NPI', headerName: 'NPI', flex: 1, minWidth: 140, renderCell: renderTextCell },
		{ field: 'Contact', headerName: 'Mobile', flex: 1, minWidth: 150, renderCell: renderTextCell },
		{ field: 'Address', headerName: 'Address', flex: 1.4, minWidth: 220, renderCell: renderTextCell },
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'action',
			headerName: 'Action',
			description: 'This column has a value getter and is not sortable.',
			sortable: false,
			flex: 0.5,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			// renderCell: (params) => (
			// 	<>
			// 		<Tooltip title="Edit User">
			// 			<BorderColorOutlinedIcon
			// 				fontSize="small"
			// 				style={{ marginLeft: 5, cursor: 'pointer' }}
			// 				onClick={() => handleEdit(params)}
			// 			/>
			// 		</Tooltip>

			// 		<Tooltip title="Delete User">
			// 			<DeleteOutlinedIcon
			// 				fontSize="small"
			// 				style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
			// 				onClick={() => handleDeleteUser(params)}
			// 			/>
			// 		</Tooltip>
			// 	</>
			// ),
			renderCell: (params) => {
				return (
					<div>
						<IconButton
							aria-label="more"
							id="long-button"
							aria-controls={editDelete_pop_opens ? 'long-menu' : undefined}
							aria-expanded={editDelete_pop_opens ? 'true' : undefined}
							aria-haspopup="true"
							onClick={(event) => {
								handleClickED(event, params);
							}}
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							sx={{ marginTop: '-1.5%' }}
							id="long-menu"
							anchorEl={anchorED}
							open={editDelete_pop_opens}
							onClose={handleCloseED}
							PaperProps={{
								style: {
									width: '83px',
									width: '72px',
									borderRadius: '7px',
									boxShadow: '0px 1px 10px 0px #00000040',
								},
							}}
						>
							<MenuItem onClick={() => handleEdit()} sx={{ fontSize: '14px' }}>
								Edit
							</MenuItem>
							<MenuItem
								onClick={() => handleDeleteUser()}
								sx={{ fontSize: '14px', color: '#ED2828' }}
							>
								Delete
							</MenuItem>
						</Menu>
					</div>
				);
			},
		},
	];

	// const open = Boolean(anchorEl);
	// const handleClick = (event) => {
	// 	setAnchorEl(event.currentTarget);
	// };
	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	return (
		<div>
			{loading ? (
				<BrandedLoader
					title="Loading staff"
					text="Preparing staff records"
					minHeight="45vh"
				/>
			) : (
				<Box
					sx={{
						width: '100%',
						background: '#fff',
						border: '1px solid #dce8f5',
						borderRadius: '8px',
						overflow: 'hidden',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: { xs: 'flex-start', sm: 'center' },
							gap: 2,
							flexDirection: { xs: 'column', sm: 'row' },
							p: 2,
							borderBottom: '1px solid #edf2f8',
						}}
					>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
							<Box
								sx={{
									width: 48,
									height: 48,
									borderRadius: '8px',
									background: '#2f6edb',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									color: '#fff',
								}}
							>
								<GroupOutlined sx={{ fontSize: 26 }} />
							</Box>
							<Box>
								<Typography sx={{ color: '#0b1f42', fontFamily: 'Poppins', fontSize: '18px', fontWeight: 700, lineHeight: 1.2 }}>
									Staff Members
								</Typography>
								<Typography sx={{ color: '#64748b', fontFamily: 'Poppins', fontSize: '13px', fontWeight: 500, mt: 0.4 }}>
									Manage your practice staff and their information
								</Typography>
							</Box>
						</Box>
						<Button
							// onClick={() => renderHandleFromChild?.('addStaff')}
							onClick={() => setOpenAddStaffModal(true)}
							startIcon={<Add />}
							sx={{
								height: '42px',
								px: 2.4,
								borderRadius: '7px',
								backgroundColor: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
								'&:hover': { backgroundColor: '#245fc5' },
							}}
						>
							Add Staff
						</Button>
					</Box>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 2,
							flexWrap: 'wrap',
							p: 2,
						}}
					>
						<TextField
							size="small"
							value={searchText}
							onChange={(event) => setSearchText(event.target.value)}
							placeholder="Search by name, specialty, NPI, or phone"
							sx={{
								width: { xs: '100%', sm: 360 },
								'& .MuiOutlinedInput-root': {
									height: '40px',
									borderRadius: '6px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									color: '#0b2450',
									'& fieldset': { borderColor: '#d7e3f4' },
									'&:hover fieldset': { borderColor: '#b8c9df' },
									'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
								},
							}}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search sx={{ color: '#526f9f', fontSize: 22 }} />
									</InputAdornment>
								),
							}}
						/>
						<Select
							size="small"
							value={specialtyFilter}
							displayEmpty
							onChange={(event) => setSpecialtyFilter(event.target.value)}
							sx={{
								width: 210,
								height: '40px',
								borderRadius: '6px',
								fontFamily: 'Poppins',
								fontSize: '13px',
								color: '#0b2450',
								'& fieldset': { borderColor: '#d7e3f4' },
								'&:hover fieldset': { borderColor: '#b8c9df' },
								'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
							}}
						>
							<MenuItem value="">All Specialties</MenuItem>
							{specialties.map((specialty) => (
								<MenuItem key={specialty} value={specialty}>
									{specialty}
								</MenuItem>
							))}
						</Select>
					</Box>
					<Box
						sx={{
							px: 2,
							pb: 2,
							height: 'calc(100vh - 320px)',
							maxHeight: '760px',
							minHeight: '420px',
							overflow: 'hidden',
						}}
					>
						<DataGrid
							rows={filteredRows}
							rowHeight={42}
							columnHeaderHeight={42}
							columns={columns}
							initialState={{
								pagination: { paginationModel: { pageSize: 10 } },
							}}
							pageSizeOptions={[10, 25, 50]}
							// checkboxSelection
							disableRowSelectionOnClick
							autoHeight={filteredRows.length <= 10}
							sx={{
								border: '1px solid #dce8f5',
								borderRadius: '6px',
								color: '#0b2450',
								fontFamily: 'Poppins',
								'& .MuiDataGrid-columnHeaders': {
									background: '#f3f7fc',
									color: '#233b63',
									fontFamily: 'Poppins',
									fontWeight: 700,
									fontSize: '13px',
									borderBottom: '1px solid #dce8f5',
								},
								'& .MuiDataGrid-columnHeaderTitle': {
									fontWeight: 700,
								},
								'& .MuiDataGrid-cell': {
									borderBottom: '1px solid #edf2f8',
									outline: 'none !important',
								},
								'& .MuiDataGrid-row:hover': {
									backgroundColor: '#f8fbff',
								},
								'& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
									outline: 'none',
								},
								'& .MuiDataGrid-footerContainer': {
									justifyContent: 'flex-end',
									backgroundColor: '#fff',
									borderTop: '1px solid #edf2f8',
									minHeight: '58px',
									px: 1,
								},
								'& .MuiTablePagination-root': {
									color: '#0b2450',
									fontFamily: 'Poppins',
								},
								'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 600,
								},
								'& .MuiTablePagination-select': {
									fontFamily: 'Poppins',
									fontSize: '13px',
								},
								'& .MuiTablePagination-actions button': {
									border: '1px solid #d7e3f4',
									width: '34px',
									height: '34px',
									mx: 0.4,
								},
							}}
						/>
					</Box>
					<AddStaff
						openModal={openAddStaffModal}
						setOpenModal={setOpenAddStaffModal}
						fetchStaff={fetchStaff}
						openSanckbarFromChild={setOpenSnackbar}
					/>

					{/* Modal Structure Design */}
					<Modal
						open={openModal}
						// onClose={handleCloseModal}
						aria-labelledby="edit-modal-title"
						aria-describedby="edit-modal-description"
						sx={{
							'& .MuiModal-backdrop': {
								opacity: '0.75 !important',
							},
							'& .MuiInputLabel-root': modalLabelSx,
							'& .MuiTextField-root, & .MuiFormControl-root': {
								'& .MuiOutlinedInput-root': modalFieldSx['& .MuiOutlinedInput-root'],
								'& .MuiInputBase-input': modalFieldSx['& .MuiInputBase-input'],
							},
						}}
					>
						<Box sx={style}>
							<Grid container lg={12} xs={12} md={12} sm={12}>
								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									xl={12}
									justifyContent="center"
								>
									<Box
										sx={{
											width: '100%',
											height: '60px',
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											px: 2,
											borderBottom: '1px solid #edf2f8',
										}}
									>
										<Typography
											sx={{
												fontFamily: 'Poppins',
												fontSize: '20px',
												fontWeight: 700,
												color: '#111827',
											}}
										>
											Edit Staff
										</Typography>
										<IconButton onClick={handleCloseModal} sx={{ color: '#475569' }}>
											<CancelIcon sx={{ fontSize: '22px' }} />
										</IconButton>
									</Box>
								</Grid>
							</Grid>
							<Grid
								container
								spacing={2.2}
								sx={{ p: 2.4, maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}
							>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Title<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Title"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Title}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Title && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Title}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										First Name<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Fname"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Fname}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Fname && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Fname}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Last Name<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Lname"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Lname}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Lname && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Lname}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										DOB<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="DOB"
										type="date"
										size="small"
										fullWidth
										disableUnderline
										value={dayjs(modalValues?.DOB).format('YYYY-MM-DD')}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
										error={
											modalValues?.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
										}
										helperText={
											modalValues?.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
												? '*Please Add Accurate DOB'
												: ''
										}
									/>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Speciality<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Specialty"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Specialty}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Specialty && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Specialty}
										</div>
									)}{' '}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Gender<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<Select
										name="Gender"
										size="small"
										fullWidth
										displayEmpty
										value={modalValues?.Gender || ''}
										onChange={targetModalValue}
										MenuProps={modalSelectMenuProps}
										renderValue={(selected) => {
											if (!selected) {
												return <span style={{ color: '#8b9ab0' }}>Select gender</span>;
											}
											return selected === 'M' ? 'Male' : 'Female';
										}}
										sx={modalSelectSx}
									>
										<MenuItem value="">Select gender</MenuItem>
										<MenuItem value={'M'}>Male</MenuItem>
										<MenuItem value={'F'}>Female</MenuItem>
									</Select>
								</Grid>
								<Grid
									item
									lg={6}
									xs={6}
									md={6}
									sm={6}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										NPI<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="NPI"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.NPI}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.NPI && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.NPI}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={6}
									xs={6}
									md={6}
									sm={6}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Mobile<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<MaskedInput
										required
										value={modalValues?.Contact}
										onChange={handleInputChange}
										name="Contact"
										mask={[
											'(',
											/\d/,
											/\d/,
											/\d/,
											')',
											' ',
											/\d/,
											/\d/,
											/\d/,
											'-',
											/\d/,
											/\d/,
											/\d/,
											/\d/,
										]}
										style={{
											...modalMaskedInputStyle,
										}}
									/>
									{errors.Contact && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Contact}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								{/* <Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Email
									</InputLabel>
									<TextField
										// value={location?.NPI}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, NPI: e.target.value }))
										// }
										name="Email"
										type="email"
										size="small"
										fullWidth
										disableUnderline
										value={'Not Found API'}
										sx={{
											// border: '1px solid #00000026',
											// boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
											// padding: '6px 3px',
											borderRadius: '4px',
										}}
									/>
								</Grid> */}

								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									xl={12}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Address
									</InputLabel>
									<TextField
										name="Address"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Address}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										City
									</InputLabel>
									<TextField
										name="City"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.City}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.City && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.City}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										State
									</InputLabel>
									<TextField
										name="State"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.State}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.State && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.State}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ p: 0 }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										ZIP
									</InputLabel>
									<TextField
										name="Zip"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Zip}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Zip && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Zip}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								{/* <Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Comments
									</InputLabel>
									<TextField
										name="Comments"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues.Comments}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid> */}
								<Box
									width={'100%'}
									display={'flex'}
									justifyContent={'flex-end'}
									gap={1.5}
									sx={{
										pt: 1,
									}}
								>
									<Button
										onClick={handleCloseModal}
										sx={{
											height: '40px',
											minWidth: 126,
											borderRadius: '6px',
											border: '1px solid #cfd8e6',
											color: '#2f4467',
											fontFamily: 'Poppins',
											fontSize: '13px',
											fontWeight: 700,
											textTransform: 'none',
										}}
									>
										Cancel
									</Button>
									<Button
										disabled={
											errors?.Title ||
											errors?.Fname ||
											errors?.Lname ||
											errors?.City ||
											errors?.Contact ||
											errors?.Specialty ||
											errors?.NPI ||
											errors?.State ||
											errors?.Zip ||
											modalValues.DOB >=
											dayjs(new Date()).format('YYYY-MM-DD') ||
											modalValues.DOB == ''
										}
										startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px !important' }} />}
										sx={{
											height: '40px',
											minWidth: 142,
											borderRadius: '6px',
											backgroundColor: `${errors?.Title || errors?.Fname || errors?.Lname || errors?.City || errors?.Contact || errors?.NPI || errors?.State || errors?.Zip || modalValues.DOB >= dayjs(new Date()).format('YYYY-MM-DD') || modalValues.DOB == '' || errors?.Specialty ? '#cbd5e1' : '#2f6edb'}`,
											color: '#fff',
											fontFamily: 'Poppins',
											fontSize: '13px',
											fontWeight: 700,
											textTransform: 'none',
											boxShadow: `${errors?.Title || errors?.Fname || errors?.Lname || errors?.City || errors?.Contact || errors?.NPI || errors?.State || errors?.Zip || modalValues.DOB >= dayjs(new Date()).format('YYYY-MM-DD') || modalValues.DOB == '' || errors?.Specialty ? 'none' : '0 4px 10px rgba(47, 110, 219, 0.2)'}`,
											'&:hover': {
												backgroundColor: `${errors?.Title || errors?.Fname || errors?.Lname || errors?.City || errors?.Contact || errors?.NPI || errors?.State || errors?.Zip || modalValues.DOB >= dayjs(new Date()).format('YYYY-MM-DD') || modalValues.DOB == '' || errors?.Specialty ? '#cbd5e1' : '#245fc5'}`,
											},
										}}
										onClick={() => updateModalValues(modalValues)}
									>
										Update Staff
									</Button>
								</Box>
							</Grid>
						</Box>
					</Modal>

					{/*Delete Dialog Structure */}

					<Dialog
						open={deletePopupOpen}
						onClose={handleDialogClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							sx: {
								width: 'min(410px, calc(100vw - 32px))',
								borderRadius: '8px',
								boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
								m: 0,
								overflow: 'hidden',
							},
						}}
					>
						<DialogTitle
							id="responsive-dialog-title"
							sx={{
								width: '100%',
								display: 'flex',
								justifyContent: 'flex-end',
								alignItems: 'center',
								p: '14px 14px 0',
							}}
						>
							<IconButton
								sx={{ width: 32, height: 32, color: '#64748b' }}
								size="small"
								onClick={deleteCancelPopup}
							>
								<CloseIcon sx={{ fontSize: '20px' }} />
							</IconButton>
						</DialogTitle>
						<DialogContent sx={{ p: 0, overflow: 'visible' }}>
							<Box sx={{ px: 3, pt: 1.2, pb: 3 }}>
								<Box
									sx={{
										width: 64,
										height: 64,
										borderRadius: '50%',
										background: '#fff1f2',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										mx: 'auto',
										mb: 2.2,
										boxShadow: '0 0 0 8px #fff7f8',
									}}
								>
									<DeleteOutlinedIcon sx={{ color: '#ef4444', fontSize: 30 }} />
								</Box>
								<Typography
									textAlign="center"
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 500,
										fontSize: '15px',
										color: '#1f2937',
										mb: 1,
									}}
								>
									Are you sure you want to delete this staff member?
								</Typography>
								<Typography
									textAlign="center"
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '14px',
										color: '#005cff',
										textTransform: 'uppercase',
										wordBreak: 'break-word',
										lineHeight: 1.5,
									}}
								>
									{deleteUser}
								</Typography>
							</Box>
						</DialogContent>
						<Box
							sx={{
								display: 'grid',
								gridTemplateColumns: '1fr 1fr',
								gap: 1.5,
								px: 3,
								py: 2.5,
								borderTop: '1px solid #edf2f8',
							}}
						>
							<Button
								onClick={deleteCancelPopup}
								startIcon={<CloseIcon sx={{ fontSize: '18px !important' }} />}
								sx={{
									height: 42,
									borderRadius: '6px',
									border: '1px solid #d7e3f4',
									color: '#ef4444',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									'&:hover': {
										background: '#fff5f5',
										borderColor: '#fecaca',
									},
								}}
							>
								No
							</Button>
							<Button
								onClick={() => {
									deleteStaff(deleteID, deleteStatus);
								}}
								startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px !important' }} />}
								sx={{
									height: 42,
									borderRadius: '6px',
									backgroundColor: '#2f6edb',
									color: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
									'&:hover': {
										backgroundColor: '#245fc5',
									},
								}}
							>
								Yes
							</Button>
						</Box>
					</Dialog>

					{/* Show Snackbar After Deletion */}

					<Snackbar
						autoHideDuration={1500}
						open={openSnackbar}
						onClose={handleCloseSnackbar}
						anchorOrigin={{
							vertical: 'center',
							horizontal: 'center',
						}}
					>
						<Alert
							onClose={handleCloseSnackbar}
							severity={severity}
							variant="filled"
							sx={{
								width: '100%',
								height: '4rem',
								textAlign: 'center',
								fontSize: '1.1rem',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={() => {
											handleCloseSnackbar();
										}}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '16px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{severity === 'error'
								? 'Staff Deleted!'
								: 'Staff Updated Successfully !'}
						</Alert>
					</Snackbar>
				</Box>
			)}
		</div>
	);
}

ViewStaff.propTypes = {
	renderHandleFromChild: PropTypes.func,
};

export default ViewStaff;
